module.exports = __webpack_public_path__ + "img/erweima.d41cc0cc.png";